import { useNavigate } from '@tanstack/react-router';
import { BiCheckCircle } from 'react-icons/bi';
import { Button, Link, Text, VStack } from 'ui_2';
import { useBuyGiveawayStore } from './-buyGiveawayStore';
import { useArcadeStoreState } from '@src/hooks/useArcadeStoreState';
import { Route as giveaway_buy_route } from '@routes/giveaways/$programId/index';
import { Route as index_route } from '@routes/index';
import { useBreakpoints } from '@puzzlehq/frontend-utils';

const Confirmed = () => {
  const { isPuzzleWalletWebview } = useArcadeStoreState();

  const [createEventResponse, _close] = useBuyGiveawayStore((state) => [
    state.createEventResponse,
    state.close,
  ]);
  const navigate = useNavigate({ from: giveaway_buy_route.fullPath });

  const eventId = createEventResponse?.eventId;

  const { isSmall } = useBreakpoints();

  return (
    <VStack className='h-full w-full gap-8'>
      <VStack className='flex-grow' />
      <VStack className='items-center gap-2 text-center'>
        <VStack className='items-center gap-2 text-center'>
          <BiCheckCircle size={68} className='text-green-400' />
          <Text font='bold-md'>Giveaway Entry Submitted!</Text>
        </VStack>
        <VStack className='w-full items-center'>
          <Text font={isSmall ? 'regular-md' : 'regular-xs'}>
            Your giveaway entry will land on chain soon.
          </Text>
          {isPuzzleWalletWebview && eventId && (
            <Link
              onClick={async () => {
                window.open(
                  `https://app.puzzle.online/event?eventId=${eventId}`
                );
              }}
            >
              View your transaction
            </Link>
          )}
        </VStack>
      </VStack>
      <VStack className='flex-grow' />
      <VStack className='w-full gap-4'>
        <Button fullWidth onClick={() => _close()}>
          Buy more entries
        </Button>
        <Link
          className='self-center '
          variant='black'
          onClick={() => {
            if (isPuzzleWalletWebview) {
              window.open(`https://app.puzzle.online/store`);
            } else {
              navigate({
                to: index_route.to,
              }).then(() => _close());
            }
          }}
        >
          Return to store
        </Link>
      </VStack>
    </VStack>
  );
};

export default Confirmed;
